/*
 * Configurateur de porte-alliance — Broderies de caractère
 * Vanilla JS, aucune dépendance. Dessine l'aperçu en SVG, choisit la variante
 * Shopify correspondante (date / fleurs / liaison) et remplit les propriétés
 * de ligne (properties[...]) envoyées avec la commande.
 */
(function () {
  'use strict';

  // Fils proposés. Ajouter / retirer une ligne suffit pour modifier la palette.
  var THREADS = [
    { name: 'Blanc cassé', hex: '#f1ece2' },
    { name: 'Rose poudré', hex: '#e6a9b4' },
    { name: 'Framboise', hex: '#c94f72' },
    { name: 'Bordeaux', hex: '#7a2338' },
    { name: 'Terracotta', hex: '#c0654a' },
    { name: 'Jaune', hex: '#f2d24b' },
    { name: 'Or', hex: '#c4a052' },
    { name: 'Sauge', hex: '#9aae8c' },
    { name: 'Vert feuillage', hex: '#3f7a4a' },
    { name: 'Vert foncé', hex: '#1e4a26' },
    { name: 'Bleu ciel', hex: '#8fb4d6' },
    { name: 'Turquoise', hex: '#4bb3d9' },
    { name: 'Lavande', hex: '#a39fd4' },
    { name: 'Violet', hex: '#3f2a9e' },
    { name: 'Indigo', hex: '#2b1d86' },
    { name: 'Bleu marine', hex: '#2f3a6e' },
    { name: 'Noir', hex: '#2a2a2a' }
  ];

  var FONTS = {
    calligraphie: { label: 'Calligraphie', family: "'Great Vibes', cursive", size: 40 },
    manuscrite: { label: 'Manuscrite', family: "'Tangerine', cursive", size: 50, weight: 700 },
    classique: { label: 'Classique', family: "'Cormorant Garamond', Georgia, serif", size: 35, italic: true }
  };

  var MOTIFS = { roses: 'Roses', hortensias: 'Hortensias' };

  // Polices du prénom des kits à motif fixe (« Prénom police 1 à 4 », cf. image Armance.png de la boutique).
  // Approximations Google Fonts, à remplacer par les polices exactes de Lorette si besoin.
  var PRENOM_FONTS = {
    '1': { family: "'Sacramento', cursive", css: 'family=Sacramento', size: 46 },
    '2': { family: "'Yellowtail', cursive", css: 'family=Yellowtail', size: 40 },
    '3': { family: "'Josefin Sans', sans-serif", css: 'family=Josefin+Sans:wght@300', size: 30, weight: 300, upper: true, spacing: 3 },
    '4': { family: "'Quicksand', sans-serif", css: 'family=Quicksand:wght@500', size: 32, weight: 500 }
  };

  // Polices Google à intégrer dans l'image jointe à la commande
  var FONT_CSS = {
    calligraphie: 'family=Great+Vibes',
    manuscrite: 'family=Tangerine:wght@700',
    classique: 'family=Cormorant+Garamond:ital,wght@1,500'
  };
  var LINKS = { 'et': '« et »', '&': '« & »', '♥': 'Un petit cœur' };
  var DATE_FORMATS = { baton: 'En bâton : 18/06/2026', lettres: 'En lettres : 18 juin 2026' };

  var COLOR_GROUPS = [
    { key: 'names', label: 'Prénoms', prop: 'Couleur prénoms' },
    { key: 'date', label: 'Date, cœur et petits détails', prop: 'Couleur date et détails' },
    { key: 'flowers', label: 'Fleurs', prop: 'Couleur fleurs' },
    { key: 'leaves', label: 'Feuillage', prop: 'Couleur feuillage' },
    { key: 'ribbon', label: 'Ruban (selon stock)', prop: 'Couleur ruban souhaitée' }
  ];

  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  var DEFAULTS = {
    name1: 'Madame', link: '♥', name2: 'Monsieur', date: '18 juin 2026', dateFormat: 'lettres',
    font: 'calligraphie', motif: 'roses', ribbon: true,
    colors: { names: '#3f2a9e', date: '#f2d24b', flowers: '#2b1d86', leaves: '#1e4a26', ribbon: '#2b1d86' }
  };

  // Correspondance entre les choix du configurateur et les options du produit Shopify.
  // On reconnaît l'option par son nom et la valeur par des mots-clés.
  var VARIANT_RULES = [
    { option: /date/, value: function (s) {
      if (s.dateFormat === 'baton') return /baton|chiffre|\d\/\d/;
      // « En lettres : 18 juin 2026 » ou simplement « 18 juin 2026 »
      return { test: function (v) { return /lettre/.test(v) || (!/\d\/\d|baton|chiffre/.test(v) && /[a-z]{3,}/.test(v)); } };
    } },
    { option: /fleur/, value: function (s) { return s.motif === 'hortensias' ? /hortensia/ : /rose/; } },
    { option: /liaison|laison|entre les/, value: function (s) {
      return s.link === '♥' ? /coeur|cœur|♥/ : s.link === '&' ? /&/ : /(^|[^a-z])et([^a-z]|$)/;
    } }
  ];

  var CX = 200, CY = 235, NAMES_Y = 232, MAX_NAMES = 262;

  // Couleurs des modèles dessinés par Lorette (appliquées au changement de motif)
  var MOTIF_COLORS = {
    roses: { flowers: '#2b1d86', ribbon: '#2b1d86' },
    hortensias: { flowers: '#4bb3d9', ribbon: '#4bb3d9' }
  };

  // Calques des dessins (pochoirs blancs) : carré englobant le cercle du dessin
  var LAYER_BOX = { x: 28, y: 63, size: 344 };

  function layer(uid, name, url, color) {
    var b = LAYER_BOX, id = uid + '-l-' + name;
    return '<mask id="' + id + '" maskUnits="userSpaceOnUse" x="' + b.x + '" y="' + b.y + '" width="' + b.size + '" height="' + b.size + '">' +
      '<image href="' + esc(url) + '" x="' + b.x + '" y="' + b.y + '" width="' + b.size + '" height="' + b.size + '"/></mask>' +
      '<rect x="' + b.x + '" y="' + b.y + '" width="' + b.size + '" height="' + b.size + '" fill="' + color + '" mask="url(#' + id + ')"/>';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function norm(v) {
    return String(v).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function isHex(v) { return /^#[0-9a-f]{6}$/i.test(v); }

  // Couleurs d'origine des dessins (kits à motif) : nommées « Couleur du modèle »
  var MODEL_COLORS = {};

  function threadName(hex) {
    hex = (hex || '').toLowerCase();
    if (MODEL_COLORS[hex]) return MODEL_COLORS[hex];
    for (var i = 0; i < THREADS.length; i++) if (THREADS[i].hex === hex) return THREADS[i].name;
    return null;
  }

  function colorLabel(hex) {
    var n = threadName(hex);
    return n ? n + ' (' + hex + ')' : 'Personnalisée (' + hex + ')';
  }

  // La date est saisie librement, telle qu'elle sera brodée
  function formatDate(s) {
    return String(s.date || '').replace(/\s+/g, ' ').trim();
  }

  // Format déduit du texte : des lettres = « en lettres », sinon « en bâton »
  function dateFormatOf(text) {
    return /[a-zà-ÿ]/i.test(text || '') ? 'lettres' : 'baton';
  }

  // Ancien format AAAA-MM-JJ (liens partagés avant le champ libre)
  function legacyDate(v, fmt) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    if (!p) return v;
    var d = parseInt(p[3], 10), m = parseInt(p[2], 10);
    if (fmt === 'baton' || !MONTHS[m - 1]) return p[3] + '/' + p[2] + '/' + p[1];
    return (d === 1 ? '1er' : d) + ' ' + MONTHS[m - 1] + ' ' + p[1];
  }

  // ---------- Dessin ----------

  function rng(seed) {
    return function () {
      seed = (seed * 16807) % 2147483647;
      return (seed - 1) / 2147483646;
    };
  }

  function qpt(b, t) {
    var u = 1 - t;
    return [u * u * b.p0[0] + 2 * u * t * b.p1[0] + t * t * b.p2[0],
            u * u * b.p0[1] + 2 * u * t * b.p1[1] + t * t * b.p2[1]];
  }

  function qtan(b, t) {
    var x = 2 * (1 - t) * (b.p1[0] - b.p0[0]) + 2 * t * (b.p2[0] - b.p1[0]);
    var y = 2 * (1 - t) * (b.p1[1] - b.p0[1]) + 2 * t * (b.p2[1] - b.p1[1]);
    var l = Math.sqrt(x * x + y * y) || 1;
    return [x / l, y / l];
  }

  function f(n) { return Math.round(n * 10) / 10; }

  function leaf(pt, angle, size, color) {
    return '<path d="M0 0C3 -3.6 9 -4 13 0C9 4 3 3.6 0 0Z" fill="' + color +
      '" transform="translate(' + f(pt[0]) + ' ' + f(pt[1]) + ') rotate(' + f(angle) + ') scale(' + (Math.round(size / 13 * 100) / 100) + ')"/>';
  }

  // Rose tissée : disque plein + une spirale plus claire
  function rose(x, y, r, color) {
    return '<circle cx="' + f(x) + '" cy="' + f(y) + '" r="' + r + '" fill="' + color + '"/>' +
      '<path d="M' + f(x - r * 0.45) + ' ' + f(y) + 'a' + f(r * 0.45) + ' ' + f(r * 0.45) + ' 0 1 1 ' + f(r * 0.45) + ' ' + f(r * 0.45) +
      '" fill="none" stroke="#fff" stroke-opacity=".28" stroke-width=".9" stroke-linecap="round"/>';
  }

  // Hortensia : pompon de petits points
  function hydrangea(x, y, r, color) {
    var o = '<circle cx="' + f(x) + '" cy="' + f(y) + '" r=".95" fill="' + color + '"/>';
    [[6, r * 0.45], [11, r * 0.85]].forEach(function (ring) {
      for (var i = 0; i < ring[0]; i++) {
        var a = i / ring[0] * Math.PI * 2 + ring[1];
        o += '<circle cx="' + f(x + Math.cos(a) * ring[1]) + '" cy="' + f(y + Math.sin(a) * ring[1]) + '" r=".95" fill="' + color + '"/>';
      }
    });
    return o;
  }

  // Petite tulipe au trait, comme sur les modèles
  function tulip(x, y, angle, color) {
    return '<g transform="translate(' + f(x) + ' ' + f(y) + ') rotate(' + f(angle) + ')" fill="none" stroke="' + color +
      '" stroke-width="1.1" stroke-linejoin="round"><path d="M0 0C-3.4 -1.6 -4 -6 -2.6 -8.4L-1.2 -6.2L0 -8.8L1.2 -6.2L2.6 -8.4C4 -6 3.4 -1.6 0 0Z"/></g>';
  }

  function branch(b, s, seed) {
    var c = s.colors, rand = rng(seed), o = '';
    o += '<path d="M' + b.p0 + 'Q' + b.p1 + ' ' + b.p2 + '" fill="none" stroke="' + c.leaves +
      '" stroke-width="1.6" stroke-linecap="round"/>';

    // Petite fourche feuillue au départ de la branche
    var t0 = qtan(b, 0.12), p0 = qpt(b, 0.12);
    var fork = [p0[0] + t0[0] * 26 + t0[1] * 10, p0[1] + t0[1] * 26 - t0[0] * 10];
    o += '<path d="M' + f(p0[0]) + ' ' + f(p0[1]) + 'Q' + f(p0[0] + t0[0] * 14) + ' ' + f(p0[1] + t0[1] * 14 + 2) + ' ' + f(fork[0]) + ' ' + f(fork[1]) +
      '" fill="none" stroke="' + c.leaves + '" stroke-width="1.2" stroke-linecap="round"/>';
    o += leaf(fork, Math.atan2(t0[1], t0[0]) * 180 / Math.PI - 20, 12, c.leaves);

    var n = 13;
    for (var i = 0; i < n; i++) {
      var t = 0.04 + i * (0.9 / (n - 1));
      var p = qpt(b, t), tg = qtan(b, t);
      var ang = Math.atan2(tg[1], tg[0]) * 180 / Math.PI;
      o += leaf(p, ang + (i % 2 ? 52 : -52), 11 + 4 * Math.sin(t * Math.PI), c.leaves);
    }

    function stemTo(t, side, dist) {
      var p = qpt(b, t), tg = qtan(b, t);
      var nx = -tg[1] * side, ny = tg[0] * side;
      var q = [p[0] + nx * dist + tg[0] * dist * 0.4, p[1] + ny * dist + tg[1] * dist * 0.4];
      if (dist > 0) {
        o += '<path d="M' + f(p[0]) + ' ' + f(p[1]) + 'L' + f(q[0]) + ' ' + f(q[1]) + '" stroke="' + c.leaves +
          '" stroke-width="1" stroke-linecap="round"/>';
      }
      return { x: q[0], y: q[1], ang: Math.atan2(ny, nx) * 180 / Math.PI + 90 };
    }

    var spots = [[0.3, -1, 8], [0.46, 1, 8], [0.62, -1, 9], [0.78, 1, 7], [0.92, -1, 8], [1, 0, 0]];
    spots.forEach(function (sp) {
      var q = stemTo(sp[0], sp[1] || 1, sp[2]);
      o += s.motif === 'hortensias' ? hydrangea(q.x, q.y, 6.4, c.flowers) : rose(q.x, q.y, 5.6, c.flowers);
    });

    if (s.motif !== 'hortensias') {
      [[0.38, 1], [0.7, -1], [0.97, 1]].forEach(function (sp) {
        var q = stemTo(sp[0], sp[1], 10);
        o += tulip(q.x, q.y, q.ang, c.date);
      });
    }

    // Semis de petits points autour de la branche
    for (var k = 0; k < 22; k++) {
      var tt = 0.25 + rand() * 0.8, pp = qpt(b, Math.min(tt, 1)), tg2 = qtan(b, Math.min(tt, 1));
      var side = rand() > 0.5 ? 1 : -1, d = 10 + rand() * 13;
      o += '<circle cx="' + f(pp[0] - tg2[1] * side * d) + '" cy="' + f(pp[1] + tg2[0] * side * d) + '" r=".85" fill="' + c.date + '"/>';
    }
    return o;
  }

  // Nœud de ruban au trait, comme sur les visuels de la boutique
  function ribbon(s) {
    var c = s.colors.ribbon;
    var st = ' fill="none" stroke="' + c + '" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
    var o = '<g>';
    o += '<path d="M192 284C172 264 134 258 128 268C121 281 152 296 192 292"' + st + '/>';
    o += '<path d="M188 287C170 281 152 278 140 272"' + st + ' stroke-width="1.1"/>';
    o += '<path d="M208 284C228 264 266 258 272 268C279 281 248 296 208 292"' + st + '/>';
    o += '<path d="M212 287C230 281 248 278 260 272"' + st + ' stroke-width="1.1"/>';
    o += '<path d="M194 294C180 310 152 332 118 346L124 352L121 357C158 342 186 318 199 297"' + st + '/>';
    o += '<path d="M206 294C220 312 246 334 284 350L280 356L286 359C248 344 216 320 202 297"' + st + '/>';
    o += '<rect x="192" y="281" width="16" height="14" rx="5" fill="#fffdf9"' + st + '/>';
    return o + '</g>';
  }

  var HEART = 'M10 18C4 13.2 0 9.6 0 5.6 0 2.4 2.4 0 5.4 0 7.4 0 9 1 10 2.6 11 1 12.6 0 14.6 0 17.6 0 20 2.4 20 5.6 20 9.6 16 13.2 10 18Z';

  function drawing(s, uid, layers) {
    var c = s.colors, F = FONTS[s.font] || FONTS.calligraphie;
    var o = '<svg class="pac__svg" viewBox="0 0 400 430" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><defs>' +
      '<pattern id="' + uid + '-lin" width="3" height="3" patternUnits="userSpaceOnUse"><path d="M0 .5H3M.5 0V3" stroke="#d6cfc2" stroke-width=".3" opacity=".45"/></pattern>' +
      '<radialGradient id="' + uid + '-fab" cx="42%" cy="38%" r="72%"><stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="#f3efe8"/></radialGradient>' +
      '<linearGradient id="' + uid + '-wood" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#efd8ac"/><stop offset=".55" stop-color="#ddb67e"/><stop offset="1" stop-color="#c79a5f"/></linearGradient>' +
      '<linearGradient id="' + uid + '-metal" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#eef0f2"/><stop offset=".55" stop-color="#a3a8ae"/><stop offset="1" stop-color="#d5d8dc"/></linearGradient>' +
      '<clipPath id="' + uid + '-clip"><circle cx="' + CX + '" cy="' + CY + '" r="168"/></clipPath>' +
      '<filter id="' + uid + '-thread" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="1.3" numOctaves="1" seed="4" result="n"/>' +
      '<feDisplacementMap in="SourceGraphic" in2="n" scale="0.6" xChannelSelector="R" yChannelSelector="G"/>' +
      '<feDropShadow dx="0" dy="0.4" stdDeviation="0.3" flood-color="#000" flood-opacity="0.2"/></filter>' +
      '<filter id="' + uid + '-hoop" x="-10%" y="-10%" width="120%" height="120%"><feDropShadow dx="0" dy="4" stdDeviation="5" flood-color="#130047" flood-opacity=".14"/></filter>' +
      '</defs>';

    if (s.sticker) {
      // Autocollant soluble : disque blanc, motif imprimé en noir
      o += '<circle cx="' + CX + '" cy="' + CY + '" r="176" fill="#ffffff" stroke="#d9d4ca" stroke-width="1" filter="url(#' + uid + '-hoop)"/>';
    } else {
      o += '<circle cx="' + CX + '" cy="' + CY + '" r="172" fill="url(#' + uid + '-fab)" filter="url(#' + uid + '-hoop)"/>';
      o += '<circle cx="' + CX + '" cy="' + CY + '" r="172" fill="url(#' + uid + '-lin)"/>';
    }

    o += '<g clip-path="url(#' + uid + '-clip)"><g' + (s.sticker ? '' : ' filter="url(#' + uid + '-thread)"') + '>';
    var L = s.layerList ? null : layers && layers[s.motif];
    if (s.layerList) {
      // Kit à motif fixe : calques du modèle, chacun teinté de la couleur de sa zone
      s.layerList.forEach(function (l) { if (!l.ribbon) o += layer(uid, l.key, l.url, s.colors[l.key] || '#1d1d1b'); });
      if (s.prenom && s.prenomPos) {
        var pf = PRENOM_FONTS[s.police] || PRENOM_FONTS['1'], pp = s.prenomPos;
        o += '<text data-prenom data-fit="' + (pp.size || pf.size) + '" data-max="' + (pp.width || 220) + '" x="' + pp.x + '" y="' + pp.y +
          '" text-anchor="middle" font-family="' + esc(pf.family) + '" font-size="' + (pp.size || pf.size) + '"' +
          (pf.weight ? ' font-weight="' + pf.weight + '"' : '') + (pf.spacing ? ' letter-spacing="' + pf.spacing + '"' : '') +
          ' fill="' + (s.colors.prenom || '#1d1d1b') + '">' + esc(pf.upper ? s.prenom.toUpperCase() : s.prenom) + '</text>';
      }
    } else if (L) {
      // Dessins de Lorette, recolorés avec les fils choisis
      o += layer(uid, 'feuillage', L.feuillage, c.leaves);
      o += layer(uid, 'fleurs', L.fleurs, c.flowers);
      o += layer(uid, 'details', L.details, c.date);
      if (s.ribbon) o += layer(uid, 'ruban', L.ruban, c.ribbon);
    } else {
      o += branch({ p0: [50, 186], p1: [132, 122], p2: [270, 114] }, s, 7);
      o += branch({ p0: [140, 372], p1: [262, 350], p2: [346, 300] }, s, 13);
    }

    if (s.noText) return closeDrawing(o, s, uid);

    // Prénoms : placés et centrés par layoutNames() une fois le texte mesuré
    var T = s.textPos || {}, NY = T.namesY || NAMES_Y, FS = Math.round(F.size * (T.scale || 1) * 10) / 10;
    var common = ' y="' + NY + '" font-family="' + esc(F.family) + '" font-size="' + FS + '"' +
      (F.italic ? ' font-style="italic"' : '') + (F.weight ? ' font-weight="' + F.weight + '"' : '') + ' fill="' + c.names + '"';
    o += '<g data-names="' + FS + '" data-y="' + NY + '" data-max="' + (T.width || MAX_NAMES) + '" data-cx="' + (T.x || CX) + '">';
    o += '<text data-n1 x="' + (CX - FS * 0.5) + '" text-anchor="end"' + common + '>' + esc(s.name1 || 'Prénom') + '</text>';
    if (s.link === '♥') {
      o += '<path data-heart d="' + HEART + '" fill="' + c.date + '" transform="translate(' + (CX - 8) + ' ' + (NY - 20) + ') scale(.8)"/>';
    } else {
      o += '<text data-link x="' + CX + '" text-anchor="middle"' + common + '>' + esc(s.link) + '</text>';
    }
    o += '<text data-n2 x="' + (CX + FS * 0.5) + '" text-anchor="start"' + common + '>' + esc(s.name2 || 'Prénom') + '</text>';
    o += '</g>';

    var date = formatDate(s);
    if (date) {
      o += '<text x="' + (T.x || CX) + '" y="' + (T.dateY || NY + 29) + '" text-anchor="middle" font-family="\'Quicksand\', \'Instrument Sans\', sans-serif" font-weight="500" font-size="' + (T.dateSize || 16) + '" fill="' +
        c.date + '">' + esc(date) + '</text>';
    }
    if (s.layerList && s.ribbon) s.layerList.forEach(function (l) { if (l.ribbon) o += layer(uid, l.key, l.url, s.colors[l.key] || '#1d1d1b'); });
    if (s.ribbon && !L && !s.layerList) o += ribbon(s);
    return closeDrawing(o, s, uid);
  }

  function closeDrawing(o, s, uid) {
    o += '</g></g>';

    if (s.sticker) return o + '</svg>';

    // Cercle de bois et vis de serrage
    o += '<circle cx="' + CX + '" cy="' + CY + '" r="176" fill="none" stroke="url(#' + uid + '-wood)" stroke-width="11"/>';
    o += '<circle cx="' + CX + '" cy="' + CY + '" r="181.4" fill="none" stroke="#b98d55" stroke-width=".8" opacity=".7"/>';
    o += '<circle cx="' + CX + '" cy="' + CY + '" r="176" fill="none" stroke="#f6e7c8" stroke-width=".6" opacity=".8"/>';
    o += '<circle cx="' + CX + '" cy="' + CY + '" r="170.6" fill="none" stroke="#b98d55" stroke-width=".8" opacity=".7"/>';
    o += '<rect x="187" y="40" width="26" height="19" rx="2.5" fill="url(#' + uid + '-wood)" stroke="#b98d55" stroke-width=".6"/>';
    o += '<rect x="168" y="45" width="66" height="8" rx="3" fill="url(#' + uid + '-metal)"/>';
    o += '<rect x="230" y="40" width="15" height="18" rx="3" fill="url(#' + uid + '-metal)"/>';
    o += '<path d="M234 42V56M238 42V56M242 42V56" stroke="#8d939a" stroke-width=".7"/>';
    return o + '</svg>';
  }

  // Mesure les prénoms, réduit la taille si besoin et centre l'ensemble
  function layoutNames(svg) {
    var pt = svg && svg.querySelector('[data-prenom]');
    if (pt && pt.getComputedTextLength) {
      var base = parseFloat(pt.getAttribute('data-fit')), max = parseFloat(pt.getAttribute('data-max'));
      pt.setAttribute('font-size', base);
      var w = pt.getComputedTextLength();
      if (w > max) pt.setAttribute('font-size', f(base * max / w));
    }
    var g = svg && svg.querySelector('[data-names]');
    if (!g) return;
    var n1 = g.querySelector('[data-n1]'), n2 = g.querySelector('[data-n2]');
    var link = g.querySelector('[data-link]'), heart = g.querySelector('[data-heart]');
    if (!n1.getComputedTextLength) return;
    var size = parseFloat(g.getAttribute('data-names'));
    var NY = parseFloat(g.getAttribute('data-y')) || NAMES_Y, MAXW = parseFloat(g.getAttribute('data-max')) || MAX_NAMES;
    var CXN = parseFloat(g.getAttribute('data-cx')) || CX;

    function measure(sz) {
      [n1, n2, link].forEach(function (t) { if (t) t.setAttribute('font-size', f(sz)); });
      var gap = sz * 0.2;
      var wl = link ? link.getComputedTextLength() : sz * 0.42;
      return { sz: sz, gap: gap, w1: n1.getComputedTextLength(), wl: wl, w2: n2.getComputedTextLength() };
    }
    var m = measure(size), total = m.w1 + m.wl + m.w2 + 2 * m.gap;
    if (total > MAXW) {
      m = measure(size * MAXW / total);
      total = m.w1 + m.wl + m.w2 + 2 * m.gap;
    }
    var x = CXN - total / 2;
    n1.setAttribute('text-anchor', 'start');
    n1.setAttribute('x', f(x));
    x += m.w1 + m.gap;
    if (link) {
      link.setAttribute('text-anchor', 'start');
      link.setAttribute('x', f(x));
    } else if (heart) {
      var k = m.wl / 20;
      heart.setAttribute('transform', 'translate(' + f(x) + ' ' + f(NY - m.sz * 0.3 - 9 * k) + ') scale(' + (Math.round(k * 1000) / 1000) + ')');
    }
    x += m.wl + m.gap;
    n2.setAttribute('text-anchor', 'start');
    n2.setAttribute('x', f(x));
  }

  // ---------- Formulaire ----------

  function pills(uid, key, label, items) {
    return '<fieldset class="pac__group"><legend class="pac__label">' + label + '</legend><div class="pac__pills">' +
      items.map(function (it) {
        return '<label class="pac__pill"><input type="radio" name="' + uid + '-' + key + '" value="' + esc(it[0]) +
          '" data-k="' + key + '"><span><i class="pac__pill-text"' + (it[2] ? ' style="' + it[2] + '"' : '') + '>' + esc(it[1]) + '</i></span></label>';
      }).join('') + '</div></fieldset>';
  }

  function textControls(uid) {
    var h = '';
    h += '<div class="pac__names">' +
      '<label class="pac__field"><span class="pac__label">Premier prénom</span><input class="pac__input" id="' + uid + '-name1" data-k="name1" maxlength="16" required autocomplete="off"></label>' +
      '<label class="pac__field"><span class="pac__label">Second prénom</span><input class="pac__input" id="' + uid + '-name2" data-k="name2" maxlength="16" required autocomplete="off"></label>' +
      '</div>';
    h += pills(uid, 'link', 'Liaison entre les prénoms', Object.keys(LINKS).map(function (k) { return [k, LINKS[k]]; }));
    h += pills(uid, 'font', 'Écriture des prénoms', Object.keys(FONTS).map(function (k) {
      var F = FONTS[k];
      return [k, F.label, 'font-family:' + F.family.replace(/'/g, '') + ';font-size:' + (k === 'manuscrite' ? '1.5em' : '1.25em') + ';line-height:1;' + (F.italic ? 'font-style:italic;' : '') + (F.weight ? 'font-weight:' + F.weight + ';' : '')];
    }));
    h += '<label class="pac__field"><span class="pac__label">Date, telle qu\'elle sera brodée</span>' +
      '<input class="pac__input pac__input--date" type="text" id="' + uid + '-date" data-k="date" maxlength="30" autocomplete="off" placeholder="Ex. : 18 juin 2026"></label>';
    return h;
  }

  function controlsHTML(uid, sticker) {
    var h = textControls(uid);
    h += pills(uid, 'motif', 'Type de fleurs', Object.keys(MOTIFS).map(function (k) { return [k, MOTIFS[k]]; }));

    if (sticker) return h;
    h += '<fieldset class="pac__group"><legend class="pac__label">Couleurs des fils <span class="pac__hint">(6 maximum)</span></legend><div class="pac__colors">';
    COLOR_GROUPS.forEach(function (g) {
      h += '<div class="pac__color" data-color="' + g.key + '"><p class="pac__sublabel">' + g.label +
        ' · <span data-cname></span></p><div class="pac__swatches">';
      THREADS.forEach(function (t) {
        h += '<button type="button" class="pac__swatch" style="--c:' + t.hex + '" data-hex="' + t.hex +
          '" aria-label="' + esc(g.label + ' : ' + t.name) + '" title="' + esc(t.name) + '"></button>';
      });
      h += '<label class="pac__swatch pac__swatch--custom" title="Autre couleur"><input type="color" data-custom aria-label="' +
        esc(g.label + ' : autre couleur') + '"></label></div></div>';
    });
    h += '</div><label class="pac__check"><input type="checkbox" id="' + uid + '-ribbon" data-k="ribbon"> Afficher le ruban sur l\'aperçu</label></fieldset>';
    return h;
  }

  function encodeState(s) {
    try { return btoa(unescape(encodeURIComponent(JSON.stringify(s)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
    catch (e) { return ''; }
  }

  function decodeState(str) {
    try { return JSON.parse(decodeURIComponent(escape(atob(str.replace(/-/g, '+').replace(/_/g, '/'))))); }
    catch (e) { return null; }
  }

  function properties(s) {
    var link = location.origin + location.pathname + '?pac=' + encodeState(s);
    var props = [
      ['Prénom 1', s.name1],
      ['Liaison', LINKS[s.link]],
      ['Prénom 2', s.name2],
      ['Date', formatDate(s) || 'À préciser'],
      ['Écriture', FONTS[s.font].label],
      ['Fleurs', MOTIFS[s.motif]]
    ];
    if (!s.sticker) COLOR_GROUPS.forEach(function (g) {
      if (g.key === 'ribbon' && !s.ribbon) return;
      props.push([g.prop, colorLabel(s.colors[g.key])]);
    });
    // Le tiret bas masque la ligne au client ; elle reste visible dans la commande.
    props.push(['_Aperçu', link]);
    return props;
  }

  // Reprend un aperçu partagé par lien (?pac=...) en ignorant les valeurs invalides
  function merge(s, saved) {
    if (!saved || typeof saved !== 'object') return;
    ['name1', 'name2'].forEach(function (k) { if (typeof saved[k] === 'string') s[k] = saved[k].slice(0, 16); });
    if (LINKS[saved.link]) s.link = saved.link;
    if (typeof saved.date === 'string') s.date = legacyDate(saved.date, saved.dateFormat).slice(0, 30);
    s.dateFormat = dateFormatOf(s.date);
    if (FONTS[saved.font]) s.font = saved.font;
    if (MOTIFS[saved.motif]) s.motif = saved.motif;
    if (typeof saved.ribbon === 'boolean') s.ribbon = saved.ribbon;
    if (saved.colors) for (var k in s.colors) if (isHex(saved.colors[k])) s.colors[k] = saved.colors[k].toLowerCase();
  }

  function findVariant(product, s) {
    if (!product || !product.variants) return null;
    var names = (product.options || []).map(function (o) { return norm(typeof o === 'string' ? o : o.name); });
    var checks = [];
    VARIANT_RULES.forEach(function (r) {
      for (var i = 0; i < names.length; i++) if (r.option.test(names[i])) { checks.push({ i: i, re: r.value(s) }); break; }
    });
    if (!checks.length) return null;
    for (var v = 0; v < product.variants.length; v++) {
      var variant = product.variants[v], ok = true;
      for (var c = 0; c < checks.length && ok; c++) ok = checks[c].re.test(norm(variant.options[checks[c].i]));
      if (ok) return variant;
    }
    return null;
  }

  function money(cents, root) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: root.getAttribute('data-currency') || 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  // ---------- Image du dessin jointe à la commande ----------

  function toDataURL(blob) {
    return new Promise(function (res, rej) {
      var r = new FileReader();
      r.onload = function () { res(r.result); };
      r.onerror = rej;
      r.readAsDataURL(blob);
    });
  }

  function fetchData(url) {
    return fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.blob();
    }).then(toDataURL);
  }

  // CSS @font-face avec les fichiers de police intégrés (sous-ensemble limité aux caractères utiles)
  function fontFaces(s) {
    if (s.noText && !s.prenom) return Promise.resolve('');
    if (s.noText) {
      var pf = PRENOM_FONTS[s.police] || PRENOM_FONTS['1'];
      return fetch('https://fonts.googleapis.com/css2?' + pf.css + '&text=' + encodeURIComponent(s.prenom + s.prenom.toUpperCase()))
        .then(function (r) { return r.text(); }).then(function (css) {
          var found = css.match(/url\((https:[^)]+)\)/g) || [];
          return Promise.all(found.map(function (m) {
            var url = m.slice(4, -1);
            return fetchData(url).then(function (data) { css = css.split(url).join(data); });
          })).then(function () { return css; });
        });
    }
    var text = encodeURIComponent((s.name1 || '') + (s.name2 || '') + (s.link || '') + 'Prénom');
    var dateText = encodeURIComponent(formatDate(s) + '0123456789/');
    var urls = [
      'https://fonts.googleapis.com/css2?' + FONT_CSS[s.font] + '&text=' + text,
      'https://fonts.googleapis.com/css2?family=Quicksand:wght@500&text=' + dateText
    ];
    return Promise.all(urls.map(function (u) {
      return fetch(u).then(function (r) { return r.text(); }).then(function (css) {
        var found = css.match(/url\((https:[^)]+)\)/g) || [];
        return Promise.all(found.map(function (m) {
          var url = m.slice(4, -1);
          return fetchData(url).then(function (data) { css = css.split(url).join(data); });
        })).then(function () { return css; });
      });
    })).then(function (parts) { return parts.join('\n'); });
  }

  function renderPNG(svgEl, s, width) {
    var clone = svgEl.cloneNode(true);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttribute('width', width);
    clone.setAttribute('height', Math.round(width * 430 / 400));
    var images = [].slice.call(clone.querySelectorAll('image'));
    return Promise.all([
      fontFaces(s),
      Promise.all(images.map(function (img) {
        var href = img.getAttribute('href');
        if (!href || href.indexOf('data:') === 0) return null;
        return fetchData(href).then(function (data) { img.setAttribute('href', data); });
      }))
    ]).then(function (res) {
      var style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      style.textContent = res[0];
      clone.insertBefore(style, clone.firstChild);
      var xml = new XMLSerializer().serializeToString(clone);
      var src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          // Laisse le temps aux polices intégrées d'être appliquées
          setTimeout(function () {
            var c = document.createElement('canvas');
            c.width = width;
            c.height = Math.round(width * 430 / 400);
            var ctx = c.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, c.width, c.height);
            ctx.drawImage(img, 0, 0, c.width, c.height);
            c.toBlob(function (blob) { blob ? resolve(blob) : reject(new Error('toBlob')); }, 'image/png');
          }, 150);
        };
        img.onerror = function () { reject(new Error('svg')); };
        img.src = src;
      });
    });
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  // ---------- Kit à motif fixe (pas de texte : version du motif + couleurs par zone) ----------
  // Le modèle vient de snippets/pac-modeles.liquid :
  // { label, versionLabel?, maxColors?, versions: [{ key, label, layers: [{ key, label, url, color }] }] }

  function motifVersion(model, s) {
    for (var i = 0; i < model.versions.length; i++) if (model.versions[i].key === s.version) return model.versions[i];
    return model.versions[0];
  }

  function motifState(model, s) {
    var v = motifVersion(model, s);
    s.version = v.key;
    s.colors = s.colors || {};
    var hasRibbon = v.layers.some(function (l) { return l.key === 'ribbon'; });
    if (model.textes) {
      // Porte-alliance sans type de fleurs : mêmes textes que le CHIC, placés selon le dessin
      ['name1', 'name2', 'link', 'font', 'date', 'dateFormat'].forEach(function (k) { if (s[k] === undefined) s[k] = DEFAULTS[k]; });
      s.dateFormat = dateFormatOf(s.date);
      s.noText = false;
      s.textPos = model.textes;
      var tc = model.textes.colors || {};
      ['names', 'date'].forEach(function (k) { if (!isHex(s.colors[k] || '')) s.colors[k] = (tc[k] || DEFAULTS.colors[k]).toLowerCase(); });
      s.ribbon = hasRibbon ? (typeof s.ribbon === 'boolean' ? s.ribbon : true) : false;
    } else {
      s.noText = true;
      s.ribbon = false;
    }
    v.layers.forEach(function (l) {
      if (l.color) MODEL_COLORS[l.color.toLowerCase()] = 'Couleur du modèle';
      if (!isHex(s.colors[l.key] || '')) s.colors[l.key] = (l.color || '#1d1d1b').toLowerCase();
    });
    if (model.textes && model.textes.colors) for (var mk in model.textes.colors) MODEL_COLORS[model.textes.colors[mk].toLowerCase()] = 'Couleur du modèle';
    s.layerList = v.layers.map(function (l) { return { key: l.key, url: l.url, ribbon: l.key === 'ribbon' }; });
    if (model.prenom) {
      s.prenom = typeof s.prenom === 'string' ? s.prenom.slice(0, model.prenom.maxLength || 14) : '';
      if (!PRENOM_FONTS[s.police]) s.police = '1';
      if (!isHex(s.colors.prenom || '')) s.colors.prenom = (model.prenom.color || '#1d1d1b').toLowerCase();
      s.prenomPos = model.prenom;
    }
    return v;
  }

  function controlsMotif(uid, model, s) {
    var v = motifVersion(model, s), h = model.textes ? textControls(uid) : '';
    if (model.versions.length > 1) {
      h += pills(uid, 'version', model.versionLabel || 'Version du motif', model.versions.map(function (x) { return [x.key, x.label]; }));
    }
    if (model.prenom) {
      h += '<label class="pac__field"><span class="pac__label">Prénom brodé (facultatif)</span>' +
        '<input class="pac__input" type="text" id="' + uid + '-prenom" data-k="prenom" maxlength="' + (model.prenom.maxLength || 14) +
        '" autocomplete="off" placeholder="Laisser vide pour le motif seul"></label>';
      h += '<div data-prenom-only' + (s.prenom ? '' : ' hidden') + '>' + pills(uid, 'police', 'Écriture du prénom', Object.keys(PRENOM_FONTS).map(function (k) {
        var pf = PRENOM_FONTS[k];
        return [k, 'Police ' + k, 'font-family:' + pf.family.replace(/'/g, '') + ';font-size:1.15em;line-height:1;' +
          (pf.weight ? 'font-weight:' + pf.weight + ';' : '')];
      })) + '</div>';
    }
    var zones = v.layers.slice();
    if (model.textes) zones = [{ key: 'names', label: 'Prénoms' }, { key: 'date', label: 'Date et cœur' }].concat(zones);
    if (model.prenom && s.prenom) zones.push({ key: 'prenom', label: 'Prénom' });
    h += '<fieldset class="pac__group"><legend class="pac__label">Couleurs des fils' +
      (model.maxColors ? ' <span class="pac__hint">(' + model.maxColors + ' maximum)</span>' : '') + '</legend><div class="pac__colors">';
    var tc = (model.textes && model.textes.colors) || {};
    zones.forEach(function (g) {
      h += '<div class="pac__color" data-color="' + esc(g.key) + '"><p class="pac__sublabel">' + esc(g.label || g.key) +
        ' · <span data-cname></span></p><div class="pac__swatches">';
      var own = (g.color || tc[g.key] || '').toLowerCase();
      var list = THREADS.slice();
      if (own && !THREADS.some(function (t) { return t.hex === own; })) list.unshift({ name: 'Couleur du modèle', hex: own });
      list.forEach(function (t) {
        h += '<button type="button" class="pac__swatch" style="--c:' + t.hex + '" data-hex="' + t.hex +
          '" aria-label="' + esc((g.label || g.key) + ' : ' + t.name) + '" title="' + esc(t.name) + '"></button>';
      });
      h += '<label class="pac__swatch pac__swatch--custom" title="Autre couleur"><input type="color" data-custom aria-label="' +
        esc((g.label || g.key) + ' : autre couleur') + '"></label></div></div>';
    });
    h += '</div>';
    if (v.layers.some(function (l) { return l.key === 'ribbon'; })) {
      h += '<label class="pac__check"><input type="checkbox" id="' + uid + '-ribbon" data-k="ribbon"> Afficher le ruban sur l\'aperçu</label>';
    }
    return h + '</fieldset>';
  }

  function propertiesMotif(model, s) {
    var v = motifVersion(model, s), props = [['Modèle', model.label]];
    if (model.textes) {
      props.push(['Prénom 1', s.name1], ['Liaison', LINKS[s.link]], ['Prénom 2', s.name2],
        ['Date', formatDate(s) || 'À préciser'], ['Écriture', FONTS[s.font].label],
        ['Couleur prénoms', colorLabel(s.colors.names)], ['Couleur date et détails', colorLabel(s.colors.date)]);
    }
    if (model.versions.length > 1) props.push([model.versionLabel || 'Version', v.label]);
    if (model.prenom) {
      props.push(['Prénom', s.prenom || 'Sans prénom']);
      if (s.prenom) props.push(['Écriture du prénom', 'Police ' + s.police]);
    }
    v.layers.forEach(function (l) {
      if (l.key === 'ribbon') { if (s.ribbon || model.textes) props.push(['Couleur ruban souhaitée', colorLabel(s.colors.ribbon)]); return; }
      props.push(['Couleur ' + (l.label || l.key).toLowerCase(), colorLabel(s.colors[l.key])]);
    });
    if (model.prenom && s.prenom) props.push(['Couleur prénom', colorLabel(s.colors.prenom)]);
    var keep = { version: s.version, colors: {}, prenom: s.prenom, police: s.police };
    if (model.textes) {
      ['name1', 'name2', 'link', 'font', 'date', 'ribbon'].forEach(function (k) { keep[k] = s[k]; });
      keep.colors.names = s.colors.names; keep.colors.date = s.colors.date;
    }
    if (model.prenom) keep.colors.prenom = s.colors.prenom;
    v.layers.forEach(function (l) { keep.colors[l.key] = s.colors[l.key]; });
    props.push(['_Aperçu', location.origin + location.pathname + '?pac=' + encodeState(keep)]);
    return props;
  }

  function mergeMotif(s, saved) {
    if (!saved || typeof saved !== 'object') return;
    if (typeof saved.version === 'string') s.version = saved.version;
    if (typeof saved.prenom === 'string') s.prenom = saved.prenom;
    ['name1', 'name2', 'date'].forEach(function (k) { if (typeof saved[k] === 'string') s[k] = saved[k].slice(0, k === 'date' ? 30 : 16); });
    if (LINKS[saved.link]) s.link = saved.link;
    if (FONTS[saved.font]) s.font = saved.font;
    if (typeof saved.ribbon === 'boolean') s.ribbon = saved.ribbon;
    if (PRENOM_FONTS[saved.police]) s.police = saved.police;
    if (saved.colors) for (var k in saved.colors) if (isHex(saved.colors[k])) s.colors[k] = saved.colors[k].toLowerCase();
  }

  // Variante : chaque option du produit est rapprochée d'un choix du client.
  // - option « prénom » : « Pas d'option prénom » ou « Prénom police N » ;
  // - autre option : valeur égale (ou contenant) au nom de la version choisie.
  function findVariantMotif(product, model, s) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (product.variants.length === 1) return product.variants[0];
    var names = (product.options || []).map(function (o) { return norm(typeof o === 'string' ? o : o.name); });
    var label = norm(motifVersion(model, s).label), key = norm(s.version || '');
    function ok(i, value) {
      var v = norm(value);
      if (model.textes) {
        for (var r = 0; r < VARIANT_RULES.length; r++) {
          if (VARIANT_RULES[r].option.test(names[i])) return VARIANT_RULES[r].value(s).test(v);
        }
      }
      if (/prenom/.test(names[i])) {
        if (!s.prenom) return /pas|sans|aucun/.test(v);
        return new RegExp('police\\s*' + s.police + '(\\D|$)').test(v);
      }
      if (model.versions.length < 2) return true;
      return v === label || v === key || v.indexOf(label) > -1 || label.indexOf(v) > -1;
    }
    for (var i = 0; i < product.variants.length; i++) {
      var opts = product.variants[i].options || [], good = true;
      for (var j = 0; j < opts.length && good; j++) good = ok(j, opts[j]);
      if (good) return product.variants[i];
    }
    return null;
  }

  function init(root) {
    if (root.__pac) return;
    root.__pac = true;
    var uid = 'pac' + Math.random().toString(36).slice(2, 8);
    var preview = root.querySelector('[data-pac-preview]');
    var controls = root.querySelector('[data-pac-controls]');
    var propsBox = root.querySelector('[data-pac-properties]');
    var idInput = root.querySelector('[data-pac-variant-id]');
    var priceEl = root.querySelector('[data-pac-price]');
    var submit = root.querySelector('[data-pac-submit]');
    var form = root.querySelector('form');
    var product = null;
    var productJson = root.querySelector('[data-pac-product]');
    if (productJson) { try { product = JSON.parse(productJson.textContent); } catch (e) { product = null; } }

    var layers = null;
    if (root.dataset.layers) { try { layers = JSON.parse(root.dataset.layers); } catch (e) { layers = null; } }
    var model = null;
    if (root.dataset.mode === 'motif') {
      var modelJson = root.querySelector('[data-pac-model]');
      try { model = JSON.parse(modelJson.textContent)[root.dataset.model] || null; } catch (e) { model = null; }
      if (!model || !model.versions || !model.versions.length) {
        controls.innerHTML = '<p class="pac__note">Modèle de dessin « ' + esc(root.dataset.model || '') + ' » introuvable : vérifiez le réglage de la section.</p>';
        return;
      }
    }
    var s = JSON.parse(JSON.stringify(DEFAULTS));
    if (model) {
      s = { version: null, colors: {} };
      var savedMotif = new URLSearchParams(location.search).get('pac');
      if (savedMotif) mergeMotif(s, decodeState(savedMotif));
      motifState(model, s);
    }
    if (root.dataset.name1) s.name1 = root.dataset.name1;
    if (root.dataset.name2) s.name2 = root.dataset.name2;
    if (root.dataset.mode === 'autocollant') {
      s.sticker = true;
      s.ribbon = false;
      for (var ck in s.colors) s.colors[ck] = '#1d1d1b';
    }
    var fromUrl = model ? null : new URLSearchParams(location.search).get('pac');
    if (fromUrl) merge(s, decodeState(fromUrl));
    if (s.sticker) { s.ribbon = false; for (var ck2 in s.colors) s.colors[ck2] = '#1d1d1b'; }

    function props() { return model ? propertiesMotif(model, s) : properties(s); }
    function renderControls() {
      controls.innerHTML = model ? controlsMotif(uid, model, s) : controlsHTML(uid, s.sticker);
      controls.querySelectorAll('[data-k]').forEach(function (el) {
        var key = el.getAttribute('data-k');
        if (el.type === 'radio') el.checked = el.value === s[key];
        else if (el.type === 'checkbox') el.checked = !!s[key];
        else el.value = s[key];
      });
    }
    renderControls();

    // Autocollant : second aperçu « une fois brodé » sous l'autocollant
    var embroidered = null;
    if (s.sticker) {
      var stageEl = preview.closest('.pac__stage');
      stageEl.classList.add('pac__stage--duo');
      var fig1 = document.createElement('figure');
      fig1.className = 'pac__duo';
      preview.parentNode.insertBefore(fig1, preview);
      fig1.appendChild(preview);
      fig1.insertAdjacentHTML('beforeend', '<figcaption class="pac__duo-label">Votre autocollant</figcaption>');
      var fig2 = document.createElement('figure');
      fig2.className = 'pac__duo';
      fig2.innerHTML = '<div class="pac__preview pac__preview--embroidered" aria-hidden="true"></div>' +
        '<figcaption class="pac__duo-label">Une fois brodé (exemple de couleurs)</figcaption>';
      fig1.insertAdjacentElement('afterend', fig2);
      embroidered = fig2.querySelector('.pac__preview');
      var cap = stageEl.querySelector('.pac__caption');
      if (cap) cap.hidden = true;
    }

    function sync() {
      controls.querySelectorAll('[data-color]').forEach(function (g) {
        var key = g.getAttribute('data-color'), hex = s.colors[key].toLowerCase(), known = false;
        g.querySelectorAll('button[data-hex]').forEach(function (b) {
          var on = b.getAttribute('data-hex') === hex;
          known = known || on;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var custom = g.querySelector('[data-custom]');
        custom.value = hex;
        custom.parentNode.classList.toggle('is-on', !known);
        g.querySelector('[data-cname]').textContent = threadName(hex) || 'couleur personnalisée';
        if (key === 'ribbon') g.hidden = !s.ribbon;
      });

      preview.innerHTML = drawing(s, uid, layers);
      if (embroidered) {
        var colors = JSON.parse(JSON.stringify(DEFAULTS.colors));
        var mc = MOTIF_COLORS[s.motif] || {};
        for (var mk in mc) colors[mk] = mc[mk];
        embroidered.innerHTML = drawing(Object.assign({}, s, { sticker: false, ribbon: false, colors: colors }), uid + 'b', layers);
        layoutNames(embroidered.querySelector('svg'));
      }
      layoutNames(preview.querySelector('svg'));

      var variant = model ? findVariantMotif(product, model, s) : findVariant(product, s);
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price, root);
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? submit.getAttribute('data-label') || 'Ajouter au panier' : 'Épuisé';
        }
      }

      var list = props();
      if (propsBox) {
        propsBox.innerHTML = list.map(function (p) {
          return '<input type="hidden" name="properties[' + esc(p[0]) + ']" value="' + esc(p[1]) + '">';
        }).join('');
      }
      root.dispatchEvent(new CustomEvent('pac:change', { bubbles: true, detail: { state: s, properties: list, variant: variant } }));
    }

    function read(el) {
      if (el.hasAttribute('data-custom')) {
        s.colors[el.closest('[data-color]').getAttribute('data-color')] = el.value.toLowerCase();
      } else if (el.hasAttribute('data-k')) {
        var key = el.getAttribute('data-k'), val = el.type === 'checkbox' ? el.checked : el.value;
        if (model && key === 'prenom') {
          var had = !!s.prenom;
          s.prenom = String(val).slice(0, (model.prenom && model.prenom.maxLength) || 14);
          if (had !== !!s.prenom) {
            var pos = el.selectionStart;
            renderControls();
            var again = controls.querySelector('[data-k=prenom]');
            if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (err) {} }
          }
          sync();
          return;
        }
        if (model && key === 'version') {
          // Changement de version : les zones peuvent différer, on reconstruit les choix de couleurs
          s.version = val;
          motifState(model, s);
          renderControls();
          sync();
          return;
        }
        if (key === 'motif' && val !== s.motif && MOTIF_COLORS[val]) {
          // Reprend les couleurs du modèle si le client n'a pas personnalisé ces fils
          var prev = MOTIF_COLORS[s.motif] || {};
          ['flowers', 'ribbon'].forEach(function (k) { if (s.colors[k] === prev[k]) s.colors[k] = MOTIF_COLORS[val][k]; });
        }
        s[key] = val;
        if (key === 'date') s.dateFormat = dateFormatOf(val);
      } else return;
      sync();
    }
    controls.addEventListener('input', function (e) { read(e.target); });
    controls.addEventListener('change', function (e) { read(e.target); });
    controls.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-hex]');
      if (!b) return;
      s.colors[b.closest('[data-color]').getAttribute('data-color')] = b.getAttribute('data-hex');
      sync();
    });

    // Easify Custom Option : le configurateur remplace ses options sur cette fiche.
    // On retire les champs qu'il injecte et on rend au bouton son rôle d'envoi du formulaire.
    function stripEasify() {
      if (!form) return;
      var formId = form.getAttribute('id');
      var nodes = [].slice.call(root.querySelectorAll('[class*="tpo_"]'))
        .concat(formId ? [].slice.call(document.querySelectorAll('[form="' + formId + '"]')) : []);
      nodes.forEach(function (el) {
        if (el === submit || el.contains(submit) || !el.parentNode) return;
        if (el.matches('[class*="tpo_"]') || /tpo|Description/.test(el.getAttribute('name') || '')) el.remove();
      });
      if (submit) {
        if (submit.type !== 'submit') submit.type = 'submit';
        [].slice.call(submit.classList).forEach(function (c) { if (c.indexOf('tpo_') === 0) submit.classList.remove(c); });
      }
    }
    if (!root.hasAttribute('data-pac-demo')) {
      stripEasify();
      if (window.MutationObserver && form) new MutationObserver(stripEasify).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['type', 'class'] });
    }

    // Boutique : au clic sur « Ajouter au panier », joint l'image du dessin puis relance le clic.
    // (Le clic est intercepté plutôt que l'envoi : des applis comme Easify gèrent elles-mêmes le bouton.)
    var fileInput = root.querySelector('[data-pac-drawing]');
    if (form && submit && fileInput && !root.hasAttribute('data-pac-demo') && window.DataTransfer && window.fetch) {
      var ready = false, busy = false;
      submit.addEventListener('click', function (e) {
        if (ready) { ready = false; return; }
        if (form.checkValidity && !form.checkValidity()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (busy) return;
        busy = true;
        submit.setAttribute('aria-busy', 'true');
        var name = (model ? 'kit-' + (root.dataset.model || 'motif') + '-' + s.version : 'porte-alliance-' + (s.name1 || 'prenom') + '-' + (s.name2 || 'prenom'))
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9-]+/g, '-').toLowerCase();
        // Dessin de commande : toujours sans ruban (le ruban est choisi selon le stock)
        var off = document.createElement('div');
        off.style.cssText = 'position:fixed;left:-10000px;top:0;width:400px;';
        off.innerHTML = drawing(Object.assign({}, s, { ribbon: false }), uid + 'png', layers);
        document.body.appendChild(off);
        layoutNames(off.querySelector('svg'));
        withTimeout(renderPNG(off.querySelector('svg'), s, 1200), 8000).then(function (blob) {
          var dt = new DataTransfer();
          dt.items.add(new File([blob], name + '.png', { type: 'image/png' }));
          fileInput.files = dt.files;
        }).catch(function () {
          fileInput.value = '';
        }).then(function () {
          off.remove();
          busy = false;
          submit.removeAttribute('aria-busy');
          if (form.requestSubmit) form.requestSubmit(submit);
          else form.submit();
        });
      }, true);
    }

    if (form && root.hasAttribute('data-pac-demo')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        root.dispatchEvent(new CustomEvent('pac:submit', { bubbles: true, detail: { state: s, properties: props() } }));
      });
    }

    sync();

    // Ordinateur : l'aperçu reste visible jusqu'à ce que son bas arrive au bouton d'ajout au panier,
    // puis les photos d'exemples défilent dessous
    var zone = root.querySelector('[data-pac-zone]');
    var stage = zone && zone.querySelector('.pac__stage');
    var anchor = submit || form;
    function sizeZone() {
      if (!zone || !anchor) return;
      if (window.innerWidth < 990) { zone.style.height = ''; return; }
      var top = zone.getBoundingClientRect().top;
      var bottom = anchor.getBoundingClientRect().bottom;
      zone.style.height = Math.max(bottom - top, stage ? stage.offsetHeight : 0) + 'px';
    }
    sizeZone();
    window.addEventListener('resize', sizeZone);

    // Téléphone : l'aperçu collé en haut remonte avec la page une fois le bouton d'ajout au panier passé
    var shift = 0;
    function releaseOnMobile() {
      if (!stage || !anchor) return;
      if (window.innerWidth >= 990) { if (shift) { stage.style.transform = ''; shift = 0; } return; }
      var naturalBottom = stage.getBoundingClientRect().bottom + shift;
      var overflow = naturalBottom - anchor.getBoundingClientRect().bottom;
      var next = overflow > 0 ? overflow : 0;
      if (next !== shift) {
        shift = next;
        stage.style.transform = shift ? 'translateY(' + (-shift) + 'px)' : '';
      }
    }
    window.addEventListener('scroll', releaseOnMobile, { passive: true });
    window.addEventListener('resize', releaseOnMobile);
    var panel = root.querySelector('.pac__panel');
    if (panel && window.ResizeObserver) new ResizeObserver(sizeZone).observe(panel);

    // Redessine une fois les polices manuscrites chargées (la largeur du texte change)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pac]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Éditeur de thème Shopify : la section est rechargée sans recharger la page
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
